import { render, staticRenderFns } from "./CustomsInfoList.vue?vue&type=template&id=772c41b6"
import script from "./CustomsInfoList.vue?vue&type=script&lang=js"
export * from "./CustomsInfoList.vue?vue&type=script&lang=js"
import style0 from "./CustomsInfoList.vue?vue&type=style&index=0&id=772c41b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports